module.exports = __webpack_public_path__ + "static/img/中国人民银行.eedbc3c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bank/中国人民银行.png
// module id = +k9T
// module chunks = 18